import React, { ReactElement, useEffect, useImperativeHandle, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Tabs } from 'antd';
import './commonTab.less';
import './../../../assets/styles/customAntTab.less';
import { customGTMEvent } from '../../../modules/crm/inPatient/service/crmUtils';

const CommonTab = React.forwardRef((
  {
    match: { path } = { path: '' },
    defaultPage,
    nestedNav,
    onTabSelectHandler,
    isUpdateTab,
    tabType,
  }: any,
  ref: any,
): ReactElement => {

  const { TabPane } = Tabs;

  const history = useHistory();
  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultPage);

  useImperativeHandle(ref, (): any => ({ setSelectedTabIndex }));

  useEffect((): any => {
    let pathName: string | string[] = history?.location?.pathname;
    if (pathName) {
      pathName = pathName.split('/');
      const fetchedRoute = nestedNav.find((ele: any): any => pathName.includes(ele.routeName));
      if (fetchedRoute && (isUpdateTab !== false)) {
        setSelectedTabIndex(fetchedRoute.routeName);
      }
    }
  }, [history?.location?.pathname]);

  const onTabSelect = (tabId: string, currentTabId: string): void => {
    if (tabId !== selectedTabIndex ) {
      if (onTabSelectHandler) {
        onTabSelectHandler(tabId, currentTabId);
      } else {
        history.push(`${path}/${tabId}`);
      }
      customGTMEvent({
        event: `Click on ${tabId}`,
      });
    }
  };
  return <React.Fragment>
    <div className={tabType === 'card' ? 'custom-ant-tab' : (tabType === 'card-profile') ? 'custom-profile-ant-tab' : ''}>
      <Tabs
        data-testid="common-tabs"
        onChange={(event: any): any => onTabSelect(event, defaultPage)} // change to get the current Tab
        activeKey={selectedTabIndex}
        type={tabType}
        className="mb-0"
      >
        {
          nestedNav.map(({ tabName, routeName, tabComponent, disabled }: any): ReactElement => {
            return <TabPane
              disabled={disabled}
              tab={tabName}
              key={routeName || tabName} >
              {tabComponent || null}
            </TabPane>;
          })
        }
      </Tabs>
    </div>
  </React.Fragment>;
});

export default CommonTab;
